var parameters={docs:{renderer:async()=>{let{DocsRenderer}=await import('./DocsRenderer-3PUGWF3O.mjs');return new DocsRenderer}}};

export { parameters };
